const formatByNameInFilter = (dataOptions) => {
  return dataOptions?.map((dataOption) => ({
    id: dataOption?.name,
    name: dataOption?.name,
  }))
}

export default formatByNameInFilter
